<template>
  <section class="personal-center-panel">
    <h2>会员服务</h2>

    <!-- 会员身份状态卡片 -->
    <div
      v-if="front.isActiveMember || front.isExpiredMember"
      class="membership-card"
      :class="{ 'is-expired': front.isExpiredMember }"
    >
      <div class="membership-card__status">
        <span class="membership-card__badge">{{ front.isExpiredMember ? '已过期' : front.memberTypeDisplayLabel }}</span>
        <span v-if="front.isPermanentMember" class="membership-card__date">长期有效</span>
        <span v-else-if="front.memberValidEndDate" class="membership-card__date">
          {{ front.isExpiredMember ? '过期于' : '有效期至' }} {{ front.formatDate(front.memberValidEndDate) }}
        </span>
      </div>
      <p v-if="front.isCouncilMemberPath" class="membership-card__hint">
        您已获指定理事职务。理事会费按本届最高一档缴纳一次；任期结束后，经秘书处确认可转为终身会员。
      </p>
      <p v-else-if="front.canUpgradeToPermanent" class="membership-card__hint">
        可升级为终身会员（一次缴清终身会费）。
      </p>
      <p v-if="front.isExpiredMember" class="membership-card__hint">
        会员资格已到期，续费后即可恢复正式会员身份与会议报名资格。
      </p>
      <p v-else-if="front.isNearExpiry && !front.isPermanentMember && !front.isCouncilMemberPath" class="membership-card__hint is-warn">
        会员即将到期（剩余 {{ front.daysUntilExpiry }} 天）。请于每年 8 月 31 日前缴纳下一年度会费，以免影响会议报名。
      </p>
    </div>

    <p v-else><strong>会员状态：</strong>{{ front.membershipStatusLabel }}</p>

    <p><strong>申请摘要：</strong>{{ applicationSummary }}</p>
    <p v-if="!front.isActiveMember && !front.isExpiredMember">{{ validityHint }}</p>
    <div class="inline-actions">
      <button type="button" class="primary-action compact" @click="front.goServicesTab('member')">前往会员服务</button>
      <button
        v-if="front.isActiveMember"
        type="button"
        class="secondary-action compact"
        @click="$router.push({ path: '/personal-center', query: { section: 'member-cert' } })"
      >电子会员证</button>
      <button v-if="front.canSubmitWithdrawApplication" type="button" class="secondary-action compact" @click="front.startWithdrawApplication">申请退会</button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PersonalMembershipPanel',
  inject: ['front'],
  computed: {
    applicationSummary() {
      return this.front.pendingApplications.length
        ? `有 ${this.front.pendingApplications.length} 项申请待审核`
        : '暂无待审核申请'
    },
    validityHint() {
      return this.front.canRenewMembershipFee || this.front.isExpiredMember
        ? '会员有效期已到，请前往会员服务办理续费。'
        : '续费与有效期信息请前往会员服务查看。'
    }
  }
}
</script>

<style scoped>
/* 会员身份卡片 */
.membership-card {
  padding: 14px 16px;
  border-radius: 8px;
  background: #f0f9eb;
  border: 1px solid #d1edc4;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.membership-card.is-expired {
  background: #f9fafb;
  border-color: #e5e7eb;
}

.membership-card__status {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.membership-card__badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  background: #dcfce7;
  color: #15803d;
}

.membership-card.is-expired .membership-card__badge {
  background: #e5e7eb;
  color: #6b7280;
}

.membership-card__date {
  font-size: 12px;
  color: var(--subtle);
}

.membership-card.is-expired .membership-card__date {
  color: #9ca3af;
}

.membership-card__hint {
  margin: 0;
  font-size: 12px;
  color: var(--subtle);
  line-height: 1.6;
}

.membership-card__hint.is-warn {
  color: #b88230;
}
</style>
